let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kTurq")).then(() => parcelRequire('8ptsW'));